import { Input } from "@progress/kendo-react-inputs";

export const MaxMinProperty = {
  propertyName: "MaxMin",
  propertyDisplay: "Range",
  propertyType: "number",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <div className="k-d-flex">
        <div className="align-columns">
          <Input
            label="minimum"
            type="number"
            name={"Min"}
            onChange={(e) => {
              handlePropertyChange({ propName: "Min", propValue: e.target.value });
            }}
            value={currentPropertyValues?.Min ?? ""}
          />
          <Input
            label="maximum"
            type="number"
            name={"Max"}
            onChange={(e) => {
              handlePropertyChange({ propName: "Max", propValue: e.target.value });
            }}
            value={currentPropertyValues?.Max ?? ""}
          />
        </div>
      </div>
    );
  },
};
